module.exports = __webpack_public_path__ + "images/minimalist-dc10fd49c0eefb04546ebdab2f3a8497.jpg";